import { useEffect, useState } from 'react';
import '../../../assets/css/KBCategories.css'
import { getKnowledgeCategories } from '../../../utils/AWSAPI';
import LoadingSpinner from '../../../utils/LoadingSpinner';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import i18n from "../../Translations/i18n/i18n";  //import i18next


function KBCategories() {
  // DATA API
  const [isLoading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  // Are we showing a modal? I.E: Error, success.
  const [isModalShowing, setModalShowing] = useState(false);
  const [isModalUncloseable, setModalUncloseable] = useState(false);

  const { t } = useTranslation("");

  const [modalHeader, setModalHeader] = useState(t('loading'));
  const [modalBody, setModalBody] = useState(<></>);
  const [modalFooter, setModalFooter] = useState(<></>);

  const closeModal = () => {
    setModalShowing(false);
  };



  const Modal = () => {
    return (
      <form>
        <div className="modal show">
          <div className="modal-content">
            <div className="modal-header">
              <h4>{modalHeader}</h4>
              {!isModalUncloseable && (
                <span className="close" onClick={closeModal}>&times;</span>
              )}
            </div>
            <div className="modal-body">{modalBody}</div>
            <div className="modal-footer">{modalFooter}</div>
          </div>
        </div>
      </form>
    );
  };

  const updateModal = (header, body, footer) => {
    setModalShowing(!isModalShowing);
    setModalHeader(header);
    setModalBody(body);
    setModalFooter(footer);
  }

  useEffect(() => {
    const loadLanguage = () => {
      const language = localStorage.getItem("language");
      if (language) {
        i18n.changeLanguage(language);
      }
    };
    loadLanguage();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getKnowledgeCategories(localStorage.getItem("language"));
        if (data.Error) {
          return updateModal(t('error'), data.Error);
        }
        setData(data);
        setLoading(false);
      } catch (err) {
        console.log(err);
      }
    };
    if (isLoading) {
      fetchData();
    }
  }, [isLoading]);

  const colors = ['darkcyan', 'lightgreen', 'yellow', 'purple', 'gray'];

  return (
    <div className="App">
      <LoadingSpinner show={isLoading} />

      {!isLoading && isModalShowing && (
        <Modal />
      )}

      {data && (
        <div className="container">
          {data.map((category, index) => (
            <Link to={"/knowledge/articles?category=" + category.sys_id} key={index} style={{ display: "contents" }}>
              <button className="category">
                <div className="bookmark" style={{ backgroundColor: colors[index % colors.length] }}></div>
                <b>{category.label}</b>
                <br />
                {t('article_count', { count: category.count })}
              </button>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}

export default KBCategories;